<!--
   The MIT License

   Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
   Copyright (c) 2018 Estonian Information System Authority (RIA),
   Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
   Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)

   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:

   The above copyright notice and this permission notice shall be included in
   all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   THE SOFTWARE.
 -->

<template>
  <div>
    <slot name="top" />
    <v-row align="center" justify="center" style="margin-top: 0">
      <transition name="fade" mode="out-in">
        <div v-if="true" class="base-full-width">
          <slot name="subTabs" />
          <div class="sticky">
            <slot name="alerts" />
          </div>
          <v-row no-gutters align="center" justify="center" class="base-full-width bottom-pad">
            <xrd-sub-view-container>
              <slot name="default" />
            </xrd-sub-view-container>
          </v-row>
        </div>
      </transition>
    </v-row>

    <v-dialog v-if="showDialog" v-model="showDialog" width="500" persistent>
      <v-card class="xrd-card">
        <v-card-title>
          <span class="text-h5">{{ $t('logout.sessionExpired') }}</span>
        </v-card-title>
        <v-card-text class="logout-text pt-4">
          {{ $t('logout.idleWarning') }}
        </v-card-text>
        <v-card-actions class="xrd-card-actions">
          <v-spacer></v-spacer>
          <xrd-button data-test="session-expired-ok-button" autofocus @click="logoutApp">
            {{ $t('action.ok') }}
          </xrd-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue';
import XrdButton from '../components/XrdButton.vue';
import XrdSubViewContainer from './XrdSubViewContainer.vue';
import { key } from '../utils';

const user = inject(key.user);
const routing = inject(key.routing);

const showDialog = computed(() => user?.isSessionAlive() === false);

function logoutApp(): void {
  user?.logout();
  routing?.toLogin();
}
</script>

<style lang="scss" scoped>
.logout-text {
  font-size: 14px !important;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 4px;
  z-index: 7; // Vuetify drop menu has z-index 8 so this goes just under those. Modals/dialogs have z-index 202
}

.base-full-width {
  width: 100%;
  padding-bottom: 40px;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
